export default {
	appealsDisplayed: 'Показано обращений',
	appealStatus: 'Статус обращения',
	waitingForHandle: 'Ожидает обработки',
	handled: 'Обработано',
	name: 'Имя',
	contactNumber: 'Контактный номер',
	email: 'Email',
	type: 'Тип',
	status: 'Cтатус',
	date: 'Дата',
	messageText: 'Текст обращения',
	handle: 'Обработать',
	areYouSureAppealIsHandled: 'Вы уверены, что обращение обработано?',
	appeals: 'Обращения'
};
